import Vue from 'vue'
import Vuex from 'vuex'
import jwt_decode from "jwt-decode";
import {
  SOCKET_ONOPEN,
  SOCKET_ONCLOSE,
  SOCKET_ONERROR,
  SOCKET_ONMESSAGE,
  SOCKET_RECONNECT,
  SOCKET_RECONNECT_ERROR
} from '../../../mutationTypes'
 
Vue.use(Vuex);
 
export default new Vuex.Store({
  state: {
    socket: {
      isConnected: false,
      message: '',
      reconnectError: false,
      isRetry: false,
      retryCount: 0,
      camera: null
    },
    signals: [],
    alarm: true,
    limit: 10,
  },
  mutations: {
    [SOCKET_ONOPEN](state, event)  {
        state.socket.isConnected = true
        state.socket.isRetry = false

    },
    [SOCKET_ONCLOSE](state, event)  {
        state.socket.isConnected = false
        state.socket.isRetry = false
    },
    [SOCKET_ONERROR](state, event)  {
        vm.$bvToast.toast("Socket bağlantısında bir sorun oluştu", {
          title: `Hata! `,
          variant: 'danger',
          solid: true
        })
    },
    // default handler called for all methods
    [SOCKET_ONMESSAGE](state, message)  {
        state.socket.message = message
    },
    // mutations for reconnect methods
    [SOCKET_RECONNECT](state, count) {
        state.socket.isConnected = false
        state.socket.isRetry = true
        state.socket.retryCount = count
        console.info(state, count)
    },
    [SOCKET_RECONNECT_ERROR](state) {
        state.socket.isConnected = false
        state.socket.isRetry = false
        state.socket.reconnectError = true;
        vm.$bvToast.toast("Socket sunucusuna yeniden bağlantı denemesi başarısız", {
          title: `Hata! `,
          variant: 'danger',
          solid: true
        })
    },
    allSignal(state, payload) {
        state.signals = payload
    },
    newSignal(state, payload) {
      let oldData = state.signals
      let newPriorty = payload.priorty;
      let i = state.alarm ? payload.is_alarm ? 0 : false : 0;
      if(oldData && oldData !== null && i == 0){
        oldData.forEach(function (item, index, array){
          if(item.id === payload.id)
              i = false
          else if(item.priorty < newPriorty)
              i = index + 1;
        })
        if(i !== false){
          oldData.splice(i, 0, payload)
          if(oldData.length > state.socket.limit)
            oldData.pop()
        }
        state.signals = oldData

      }else{
        state.signals = [payload]
      }
      
    },
    removeSignal(state, payload){
      let oldData = state.signals
      let pos = state.signals.map((e) =>{ return e.id}).indexOf(payload.signal_id)
      if(pos > -1)
        oldData.splice(pos, 1);
      state.signals = oldData
    },
    newSignalAfterBulkOpeartion(state, payload){
      //console.log('GetSignal After Bulk', payload)
    },
    camera(state, payload){
      console.log('CAMERA',payload )
      state.camera = payload

    }
  },
  actions: {
    newSignal ({commit}, message) {
      commit('newSignal', message);
    },
    signals({ commit }, message){
      commit('allSignal', message);
    },
    removeSignal({ commit }, message) {
      commit('removeSignal', message);
    },
    busySignal (context, message) {
      commit('removeSignal', message);
    },
    camera({ commit }, message){
      commit('camera', message);
    },
    processSignal(context, message) {
      //console.log(message, "newSignal")
    },
    newSignalsAfterBulkOperation(context, message){
      let params =  {
          "user_id": jwt_decode(localStorage.getItem('access_token')).user_id,
          "event" : "getsignals",
          "limit": context.state.limit,
          "is_alarm": context.state.alarm
      }
      this._vm.$socket.send(JSON.stringify(params))
    }
  }
})
 


// WEBPACK FOOTER //
// ./src/store/modules/Socket/index.js